var jquery = require('jquery');
var myname = 'Searches';
var data = [];
var LFPortal = null;
var svg_bookmarks = '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" aria-hidden="true"><path d="M12 6v42l15-15 15 15v-42zM36 0h-30v42l3-3v-36h27z"></path></svg>';
var svg_checkmark = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path></svg>';

function _exists(hash){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	return (_findIdx(hash)>=0)?true:false;
}

function _findIdx(hash){
	hash = hash.toLowerCase();
	return data.findIndex(function(search){
		return search.hash.toLowerCase() === hash;
	});
}

function _add_item(search){
	// console.log('searches._add_item(%s)', search.hash);
	var idx = _findIdx(search.hash);
	if(idx >= 0){
		// Already exists : Remove it so that it can be added again at the top
		data.splice(idx, 1);
	}
	// Add the search at the top
	data.unshift(search);
}

function _remove_item(hash){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	var idx = _findIdx(hash);
	if(idx < 0) return;
	data.splice(idx, 1);
	// LFPortal.save();
}

function _handler(){
	// console.log("%s._hander()", myname);
	var _self = jquery(this);
	var querystring = _self.data('querystring');
	add(querystring);
}

function _makeButton(querystring, state){
	// console.log('%s._makeButton(%s)', myname, state);
	var btn = jquery('<button/>')
		.addClass('c-save-search-button c-icon-link')
		.attr({type: 'button'})
		.data({querystring: querystring})
		.click(_handler)
		.on("toggle", function(event, newstate){
			var _self = jquery(this);
			if(newstate){
				_self.html(
					svg_checkmark
					+ '<span class="">'
					+ LFPortal.$t('searches.button.saved')
					+ '</span>'
				);
				_self.addClass('is-saved');
			}else{
				_self.html(
					svg_bookmarks
					+ '<span class="">'
					+ LFPortal.$t('searches.button.save')
					+ '</span>'
				);
				_self.removeClass('is-saved');
			}
		})
	;
	btn.trigger('toggle', state);
	return btn;
}

function _updateSearchDecoration(){
	// Changes the state of the search button decoration
	// console.info('%s._updateSearchDecoration()', myname);
	var listings = jquery("[data-searchparams][data-searchparams!='']");
	if(!listings.length){
		return;
	}
	listings.each(function(idx){
		// Decorate listings
		var _self = jquery(this);
		var searchhash = _self.data('searchhash') || "";
		var _issaved = _exists(searchhash);
		jquery(':button.c-save-search-button', _self).trigger('toggle', _issaved);
	});
}

function _decorateSearchResult(){
	// console.info('%s._decorateSearchResult()', myname);
	// Look for search summary and add a "save" button
	var listings = jquery("[data-searchparams][data-searchparams!='']");
	if(!listings.length){
		return;
	}
		
	listings.each(function(idx){
		// Decorate listings
		var _self = jquery(this);
		var querystring = _self.data('searchparams');
		var searchhash = _self.data('searchhash') || "";
		var _issaved = _exists(searchhash);
		_self.append(_makeButton(querystring, _issaved));
	});
}

function _removeDecoration(){
	// console.info('%s.%s()', myname, arguments.callee.name);
	// Look for marked up elements and decorate them with Add/Remove favourites buttons
	var buttons = jquery('[data-searchparams] button.c-save-search-button');
	if(!buttons.length){
		return;
	}
	buttons.remove();
}


// Public methods

function init(P){
	// console.log('%s.%s()', myname, arguments.callee.name);
	LFPortal = P;
}

function setData(searches){
	// Add bulk data
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	searches.forEach(function(search){
		data.push(search);
	});
	_decorateSearchResult();
}

function add(querystring){
	// console.log('searches.add(%s)', querystring);
	if(!LFPortal.dataset.ok){
		return;
	}
	jquery.ajax({
			url:LFPortal.endpoint('search')
		,	method: 'POST'
		, dataType: 'JSON'
		, contentType: 'application/json; charset=utf-8'
		, headers: {'Authorization': LFPortal.token()}
		, data: JSON.stringify({querystring:querystring})
	})
	.done(function(data, textStatus, jqXHR){
		_add_item(data);
		_updateSearchDecoration();
		LFPortal.gaevent('SearchAdd', querystring);
		return;
	})
	.fail(function(xhr, status, errorThrown){
	});		
	return;
}

function remove(hash){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	if(!LFPortal.dataset.ok){
		return;
	}
	if(!_exists(hash)) return;
	jquery.ajax({
			url:LFPortal.endpoint('search/' + encodeURI(hash))
		,	method: 'DELETE'
		, dataType: 'JSON'
		, contentType: 'application/json; charset=utf-8'
		, headers: {'Authorization': LFPortal.token()}
	})
	.done(function(data, textStatus, jqXHR){
		_remove_item(hash);
		LFPortal.gaevent('SearchRemove', hash);
		return;
	})
	.fail(function(xhr, status, errorThrown){
	});		
	return;
}

function clearData(){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	data = [];
	_removeDecoration();
}

export default {
	init,
	setData,
	clearData,
	remove,
	add,
	data
};


// WEBPACK FOOTER //
// ./src/portal/searches.js